/**
 * axios setup to use mock service
 */

import axios from 'axios';
import { CHECK_SESSION_ROUTE } from 'constants';
import { detectIncognito } from 'detectincognitojs';

const axiosServices = axios.create({ baseURL: process.env.REACT_APP_API_URL || 'http://localhost:7201/', withCredentials: true });

axiosServices.interceptors.request.use(
    async (config) => {
        const publicIp = localStorage.getItem('public-ip');
        // for private browsing
        await detectIncognito().then((result) => {
            config.headers['robot-browser'] = result.browserName;
            config.headers['robot-browser-private'] = result.isPrivate ? 'private' : 'normal';
        });

        if (publicIp) {
            config.headers['public-ip'] = publicIp;
        }

        return config;
    },
    (error) => {
        console.log(error);
        // auto redirect to login page if 401 response returned from api
        if (error.response && error.response.status === 401) {
            window.location.href = '/login';
        }
        return Promise.reject(error);
    }
);

// interceptor for http
axiosServices.interceptors.response.use(
    (response) => response,
    (error) => {
        // console.log(error);
        if (error.config) {
            const requestUrl = error.config.url;
            // auto redirect to login page if 401 response returned from api
            // except /auth/me -> will cause loop
            if (requestUrl !== CHECK_SESSION_ROUTE && error.response && error.response.status === 401) {
                window.location.href = '/login';
            }
        }
        return Promise.reject((error.response && error.response.data) || 'Wrong Services');
    }
);

export default axiosServices;
